import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Order, editOrder} from "../../models/order";
import {API_GET_ONE_ORDER, API_POST_ORDER, API_URL, API_GET_ORDERS, API_CHANGE_STATE, API_PUT_ORDER} from "../../constants";

/*
  Generated class for the OrdenProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OrdenProvider {

  constructor(public http: HttpClient) {

  }

  getOrder(id) {
    return this.http.get(`${API_URL}${API_GET_ONE_ORDER}${id}`);
  }

  saveOrder(data: Order) {
    return this.http.post(`${API_URL}${API_POST_ORDER}`, data);
  }

  getOrders(id) {
    return this.http.get(`${API_URL}${API_GET_ORDERS}${id}`);
  }

  changeState(id, data) {
    console.log(data);
    return this.http.patch(`${API_URL}${API_CHANGE_STATE}${id}`, data );
  }

  editOrder(id, data: editOrder) {
    return this.http.patch(`${API_URL}${API_PUT_ORDER}${id}`, data);
  }

}





// WEBPACK FOOTER //
// ./src/providers/orden/orden.ts